import { getLoadingErrorMessage } from './errorMessageFunctions';

export const LOADING = 'Please wait...';
export const ALCOHOL_CONSUMED_ERROR = getLoadingErrorMessage('alcohol consumed entries');
export const APPOINTMENTS_ERROR = getLoadingErrorMessage('appointments');
export const NO_ADVISERS_ERROR = getLoadingErrorMessage('advisers');
export const APPOINTMENT_ATTENDANCE_ERROR = getLoadingErrorMessage(
    'appointment attendance details'
);
export const ACCEPTANCE_TO_TAKE_PART_IN_SERVICE_ERROR = getLoadingErrorMessage(
    'acceptance to take part in service types'
);
export const ACTION_PLAN_DETAILS_ERROR = getLoadingErrorMessage('action plan status details');
export const APPOINTMENT_TYPES_ERROR = getLoadingErrorMessage('appointment type details');
export const ATTENDANCE_ERROR = getLoadingErrorMessage('attendance details');
export const ATTENDANCE_OUTCOMES_ERROR = getLoadingErrorMessage('attendance outcomes');
export const ATTRACTION_DETAILS_ERROR = getLoadingErrorMessage('attractions');
export const AUDIT_EVENT_HISTORY_ERROR = getLoadingErrorMessage('audit event history');
export const BARRIER_NAME_DETAILS_ERROR = getLoadingErrorMessage('barrier name details');
export const BENEFIT_CODE_DETAILS_ERROR = getLoadingErrorMessage('benefit code details');
export const BLOOD_GLUCOSE_ERROR = getLoadingErrorMessage('blood glucose entries');
export const BLOOD_PRESSURES_ERROR = getLoadingErrorMessage('blood pressure entries');
export const BLOOD_TEST_EVENTS_ERROR = getLoadingErrorMessage('blood test events');
export const BLOOD_TEST_SOURCES_ERROR = getLoadingErrorMessage('blood test sources');
export const BLOOD_TESTS_ERROR = getLoadingErrorMessage('blood tests');
export const BMI_ENTRIES_ERROR = getLoadingErrorMessage('BMI entries');
export const BUSINESS_SECTOR_DETAILS_ERROR = getLoadingErrorMessage('business sector details');
export const CALLS_ERROR = getLoadingErrorMessage('calls');
export const CALL_OUTCOME_ERROR = getLoadingErrorMessage('call outcome details');
export const CLAIM_EVENT_STATUSES_ERROR = getLoadingErrorMessage('claim event statuses');
export const CLAIM_EVENT_TYPES_ERROR = getLoadingErrorMessage('claim event types');
export const CLAIMS_ERROR = getLoadingErrorMessage('claims');
export const COMMISSIONER_COMMUNICATIONS_TYPES_ERROR = getLoadingErrorMessage(
    'commissioner communications types'
);
export const COMMUNICATION_OPT_OUT_TYPES_ERROR = getLoadingErrorMessage(
    'communication opt out types'
);
export const COMMUNICATION_TEMPLATES_ERROR = getLoadingErrorMessage('communication templates');
export const COMMUNICATION_TYPES_ERROR = getLoadingErrorMessage('communication types');
export const COMORBIDITY_ERROR = getLoadingErrorMessage('comorbidity details');
export const CONSENT_FOR_FUTURE_CONTACT_ERROR = getLoadingErrorMessage(
    'consent for future contact options'
);
export const CONTRACT_CONSTANTS_ERROR = getLoadingErrorMessage('contract constants');
export const CONTRACT_DETAILS_ERROR = getLoadingErrorMessage('contract details');
export const CONTRACT_TYPES_ERROR = getLoadingErrorMessage('contract types');
export const COURSE_TEMPLATE_HEALTH_DETAILS_ERROR = getLoadingErrorMessage(
    'course template health details'
);
export const CTW_REFERRALS_ERROR = getLoadingErrorMessage('CTW referrals');
export const CURRENT_BUSINESS_ERROR = getLoadingErrorMessage('current business');
export const CURRENTLY_TAKING_BLOOD_PRESSURE_LOWERING_MEDICATION_TYPES_ERROR =
    getLoadingErrorMessage('currently taking blood pressure lowering medication types');
export const CURRENTLY_TAKING_DIABETES_MEDICATION_TYPES_ERROR = getLoadingErrorMessage(
    'currently taking diabetes medication types'
);
export const CURRENTLY_TAKING_MEDICATION_DETAILS_ERROR = getLoadingErrorMessage(
    'currently taking medication details'
);
export const CURRENT_VACANCY_ERROR = getLoadingErrorMessage('current vacancy');
export const DAR_PRIORITIES_ERROR = getLoadingErrorMessage('DAR priorities');
export const DAR_REQUEST_TYPES_ERROR = getLoadingErrorMessage('DAR request types');
export const DAR_STATUSES_ERROR = getLoadingErrorMessage('DAR statuses');
export const DEFINED_GROUP_DETAILS_ERROR = getLoadingErrorMessage('defined group details');
export const DISABILITY_DETAILS_ERROR = getLoadingErrorMessage('disability details');
export const DUK_RISK_SCORE_ERROR = getLoadingErrorMessage('DUK risk scores');
export const HAS_DISABILITY_DETAILS_ERROR = getLoadingErrorMessage('has disability details');
export const DOCUMENT_ERROR = getLoadingErrorMessage('participant documents');
export const DOCUMENT_TYPES_ERROR = getLoadingErrorMessage('document types details');
export const DOCMAN_TRIGGER_ERROR = getLoadingErrorMessage('docman triggers');
export const ELIGIBILITY_GROUPS_ERROR = getLoadingErrorMessage('eligibility group details');
export const EMPLOYMENT_STATUS_DETAILS_ERROR = getLoadingErrorMessage('employment status details');
export const EMPLOYMENT_TYPE_DETAILS_ERROR = getLoadingErrorMessage('employment type details');
export const EOI_CONSENT_DETAILS_ERROR = getLoadingErrorMessage('eoi consent details');
export const ETHNICITY_DETAILS_ERROR = getLoadingErrorMessage('ethnicity details');
export const FINANCIAL_REQUESTS_ERROR = getLoadingErrorMessage('financial requests');
export const FINANCIAL_REQUESTS_PAYMENT_METHOD_TYPE_ERROR = getLoadingErrorMessage(
    'financial requests payment method type details'
);
export const FINANCIAL_REQUESTS_STATUS_ERROR = getLoadingErrorMessage(
    'financial requests status details'
);
export const FINANCIAL_REQUESTS_TYPE_ERROR = getLoadingErrorMessage(
    'financial requests type details'
);
export const FORM_ERROR = getLoadingErrorMessage('form');
export const FORMS_ERROR = getLoadingErrorMessage('forms');
export const FORM_STATUS_DETAILS_ERROR = getLoadingErrorMessage('form status details');
export const FORM_TYPES_ERROR = getLoadingErrorMessage('form types');
export const FREQUENCY_DETAILS_ERROR = getLoadingErrorMessage('frequency details');
export const GENDER_ERROR = getLoadingErrorMessage('gender details');
export const GENDER_SAME_AT_BIRTH_ERROR = getLoadingErrorMessage('gender same at birth options');
export const GP_ERROR = getLoadingErrorMessage('GP details');
export const GP_PARTICIPATION_CONSENT_ERROR = getLoadingErrorMessage(
    'GP participation consent options'
);
export const HEALTH_EVENT_TYPES_ERROR = getLoadingErrorMessage('health event types');
export const HEALTH_INCIDENTS_ERROR = getLoadingErrorMessage('health incidents');
export const HOURS_PER_WEEK_DETAILS_ERROR = getLoadingErrorMessage('hours per week details');
export const HOUSING_DETAILS_ERROR = getLoadingErrorMessage('housing details');
export const IS_ON_LEARNING_DISABILITY_REGISTER_ERROR = getLoadingErrorMessage(
    'learning disability register options'
);
export const IS_ON_SMI_REGISTER_ERROR = getLoadingErrorMessage('SMI register options');
export const JOB_CENTRE_DETAILS_ERROR = getLoadingErrorMessage('job centre details');
export const JOB_READINESS_DETAILS_ERROR = getLoadingErrorMessage('job readiness details');
export const PARTICIPANT_JOB_READINESS_ERROR = getLoadingErrorMessage('participants job readiness');
export const JOB_READINESS_REASONS_DETAILS_ERROR = getLoadingErrorMessage(
    'job readiness reasons details'
);
export const PARTICIPANT_JOB_SEARCH_ERROR = getLoadingErrorMessage('participants job search');
export const JOB_SECTOR_DETAILS_ERROR = getLoadingErrorMessage('job sector details');
export const KEY_SKILLS_ERROR = getLoadingErrorMessage('key skill details');
export const LANGUAGE_DETAILS_ERROR = getLoadingErrorMessage('first language details');
export const LICENCE_DETAILS_ERROR = getLoadingErrorMessage('drivers licence details');
export const MARITAL_STATUS_DETAILS_ERROR = getLoadingErrorMessage('marital status details');
export const MAXIMUM_TRAVEL_DISTANCE_DETAILS_ERROR = getLoadingErrorMessage(
    'maximum travel distance details'
);
export const MEASUREMENT_TYPES_ERROR = getLoadingErrorMessage('measurement types');
export const MEDICATION_DISCUSSED_AND_CONFIRMED_TYPES_ERROR = getLoadingErrorMessage(
    'medication discussed and confirmed types'
);
export const MENTAL_HEALTH_DETAILS_ERROR = getLoadingErrorMessage('mental health details');
export const MOD_STATUS_DETAILS_ERROR = getLoadingErrorMessage('MOD status details');
export const OWN_PLACEMENT_DETAILS_ERROR = getLoadingErrorMessage('own placement details');
export const PARTICIPANT_POOLS_ERROR = getLoadingErrorMessage('participant pools');
export const PARTICIPANTS_ERROR = getLoadingErrorMessage('participants');
export const PARTICIPANT_STATUS_DETAILS_ERROR = getLoadingErrorMessage(
    'participant status details'
);
export const PARTICIPANT_STATUS_REASONS_ERROR = getLoadingErrorMessage(
    'participant status reason details'
);
export const PHYSICAL_ACTIVITIES_ERROR = getLoadingErrorMessage('physical activity entries');
export const PLACEMENT_EMPLOYMENT_TYPE_DETAILS_ERROR = getLoadingErrorMessage(
    'placement employment type details'
);
export const PLACEMENT_END_STATUS_DETAILS_ERROR = getLoadingErrorMessage(
    'placement end status details'
);
export const PLACEMENT_START_STATUS_DETAILS_ERROR = getLoadingErrorMessage(
    'placement start status details'
);
export const POOL_ACCEPTED_REJECTION_REASONS_DETAILS_ERROR = getLoadingErrorMessage(
    'pool accepted rejection reasons details'
);
export const POOL_REQUESTED_REJECTION_REASONS_DETAILS_ERROR = getLoadingErrorMessage(
    'pool requested rejection reasons details'
);
export const POOL_STATUS_DETAILS_ERROR = getLoadingErrorMessage('pool status details');
export const NO_PRESCRIBER_DETAILS_ERROR = getLoadingErrorMessage('prescriber details');
export const PREVIOUSLY_SUPPLIED_FIBRE_SUPPLEMENTS_ERROR = getLoadingErrorMessage(
    'previously supplied fibre supplements'
);
export const QUALIFICATION_TYPE_ERROR = getLoadingErrorMessage('qualification type details');
export const READINESS_TO_CHANGE_ERROR = getLoadingErrorMessage('readiness to change details');
export const REASON_FOR_LEAVING_ERROR = getLoadingErrorMessage('reason for leaving details');
export const REFERRALS_ERROR = getLoadingErrorMessage('referrals');
export const RELIGION_ERROR = getLoadingErrorMessage('religion details');
export const RESCUE_PACKAGE_OFFERED_DETAILS_ERROR = getLoadingErrorMessage(
    'rescue package offered details'
);
export const RESCUE_PACKAGE_TYPES_ERROR = getLoadingErrorMessage('rescue package types');
export const RESCUE_PACKAGE_DECLINED_REASON_TYPES_ERROR = getLoadingErrorMessage(
    'rescue package declined reason types'
);
export const RESCUE_PACKAGE_MEDICATION_CONFIRMATION_DETAILS_ERROR = getLoadingErrorMessage(
    'rescue package medication confirmation details'
);
export const RIGHT_TO_WORK_DOCTYPES_ERROR = getLoadingErrorMessage('right to work document types');
export const SELF_EMPLOYED_COURSE_ERROR = getLoadingErrorMessage('self employed course');
export const SELF_EMPLOYED_MANAGEMENT_COURSE_MODULE_STATUS_ERROR = getLoadingErrorMessage(
    'self employed management course module status'
);
export const SERVICE_CONSTANTS_ERROR = getLoadingErrorMessage('service constants');
export const SERVICES_ERROR = getLoadingErrorMessage('service details');
export const SEXUAL_ORIENTATION_DETAILS_ERROR = getLoadingErrorMessage(
    'sexual orientation details'
);
export const SIGNPOSTING_ORGANISATIONS_ERROR = getLoadingErrorMessage('signposting organisations');
export const SIGNPOSTINGS_ERROR = getLoadingErrorMessage('signpostings');
export const SMOKING_TYPES_ERROR = getLoadingErrorMessage('smoking types');
export const STEPS_ERROR = getLoadingErrorMessage('steps entries');
export const T2DR_HEALTH_DATA_ERROR = getLoadingErrorMessage('T2DR health data entries');
export const T2DR_CONSUMPTION_DETAILS_ERROR = getLoadingErrorMessage('T2DR consumption details');
export const TIME_UNEMPLOYED_DETAILS_ERROR = getLoadingErrorMessage('time unemployed details');
export const TRANSPORT_METHOD_DETAILS_ERROR = getLoadingErrorMessage('transport methods');
export const UNIQUE_IDENTIFIERS_ERROR = getLoadingErrorMessage('unique identifiers');
export const USER_EVENT_TYPE_ERROR = getLoadingErrorMessage('user event types');
export const VACANCY_REJECTION_REASONS_DETAILS_ERROR = getLoadingErrorMessage(
    'vacancy rejection reasons details'
);
export const VACANCY_STAGE_DETAILS_ERROR = getLoadingErrorMessage('vacancy stage details');
export const WAIST_MEASUREMENTS_ERROR = getLoadingErrorMessage('waist measurements');
export const WELLBEING_ERROR = getLoadingErrorMessage('wellbeing details');
export const WORK_CONDITIONALITY_GROUPS_ERROR = getLoadingErrorMessage(
    'work conditionality groups'
);
export const WORK_CONFIDENCE_DETAILS_ERROR = getLoadingErrorMessage('work confidence details');
export const WORK_HISTORY_ERROR = getLoadingErrorMessage('work history details');
